class App {
  constructor($el, args) {
    $el.keyup((event) => {
      if (event.keyCode === 27) {
        args.queueManager.trigger('escape')
      }
    });
  }
}

export default App



// WEBPACK FOOTER //
// ./scripts/components/App.js